export const claimsDocLink = "https://cirencester-friendly.co.uk/documents/Member/006_General/Our-Guide-to-Claims.pdf";

// Regex works with "Unnecessary escape character: \#""
// eslint-disable-next-line
export const uktelRegex = /^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/;

export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const nonRequiredFields = {
  'member_contractNumber': '',
  'member_addressLine2': '',
  'member_country': '',
  'doctor_addressLine2': '',
  'doctor_country': '',
  'occupation_main_further': '',
}

export const nonRequiredMainEmployed = {
  'occupation_addressLine2': '',
}

export const nonRequiredFieldsDocChanged = {
  'doctor_changed_addressLine2': '',
  'doctor_changed_country': ''
}

export const nonRequiredFieldsAccountant1 = {
  'occupation_accountant_address_Line2': ''
}

export const nonRequiredFieldsOcc2nd = {
  'occupation_2nd_further': '',
  'occupation_2nd_addressLine2': '',
}

export const nonRequiredFieldsAccountant2 = {
  'occupation_2nd_accountant_addressLine2': ''
}

export const occupationStatusesWithAccountant = [
  "Self Employed / Sole Trader",
  "Company Director",
  "Partnership"
]

export const selectYesNo = [
  { id: "", value: "-- Please Select --" },
  { id: "Yes", value: "Yes" },
  { id: "No", value: "No" },
];

export const selectOccupationalStatus = [
  { id: "", value: "--Please Select --" },
  { id: "Employed" , value: "Employed" },
  { id: "Self Employed / Sole Trader" , value: "Self Employed / Sole Trader" },
  { id: "Company Director" , value: "Company Director" },
  { id: "Partnership" , value: "Partnership" },
  { id: "House Person" , value: "House Person" },
  { id: "Unemployed" , value: "Unemployed" },
];

export const employSelectCondition = [
  "Self Employed / Sole Trader",
  "Company Director",
  "Partnership"
];

export const employSelectCondition3 = ["Employed"];

export const selectRelationtoClient = [
  { id: "", value: "--Please Select --" },
  { id: "Financial Adviser", value: "Financial Adviser" },
  { id: "Partner / Spouse", value: "Partner / Spouse" },
  { id: "Other", value: "Other" },
];

export const selectTitlePrefix = [
  { id: "", value:"-- Please Select --" },
  { id: "Mr", value: "Mr" },
  { id: "Mrs", value: "Mrs" },
  { id: "Dr", value: "Dr" },
  { id: "Miss", value: "Miss" },
  { id: "Ms", value: "Ms" },
  { id: "Admiral", value: "Admiral" },
  { id: "Brigadier", value: "Brigadier" },
  { id: "Captain", value: "Captain" },
  { id: "Colonel", value: "Colonel" },
  { id: "General", value: "General" },
  { id: "Group Captain", value: "Group Captain" },
  { id: "Lance Corporal", value: "Lance Corporal" },
  { id: "Lt. Colonel", value: "Lt. Colonel" },
  { id: "Major", value: "Major" },
  { id: "Master", value: "Master" },
  { id: "Professor", value: "Professor" },
  { id: "Mx", value: "Mx" },
  { id: "Reverend", value: "Reverend" },
  { id: "Wing Commander", value: "Wing Commander" },
  { id: "Canon", value: "Canon" },
  { id: "The Secretary", value: "The Secretary" },
  { id: "The Executor", value: "The Executor" },
];

export const selectBankAccount = [
  { id: "", value:"-- Please Select --" },
  { id: "The account where you pay premiums from", value:"The account where you pay premiums from" },
  { id: "A different account", value:"A different account" },
];

export const reviewFields = [
  { format: '', required: 'Yes', pagetab: '2', id: 'areYouMember', question: 'Are you the member?'},
  { format: '', required: 'Yes', pagetab: '2', id: 'formFilledOutByRelationship', question:'Relationship to claimant'},
  { format: '', required: 'Yes', pagetab: '2', id: 'formFilledOutByName', question: 'Form filled by'},
  { format: '', required: 'No', pagetab: '2', id: 'member_contractNumber', question: 'Contract Number'},
  { format: '', required: 'Yes', pagetab: '2', id: 'member_title', question: 'Title'},
  { format: '', required: 'Yes', pagetab: '2', id: 'member_firstName', question: 'First Name'},
  { format: '', required: 'Yes', pagetab: '2', id: 'member_lastName', question: 'Last Name'},
  { format: '', required: 'Yes', pagetab: '2', id: 'member_postcode', question: 'Postcode'},
  { format: '', required: 'Yes', pagetab: '2', id: 'member_addressLine1', question: 'Address 1'},
  { format: '', required: 'No', pagetab: '2', id: 'member_addressLine2', question: 'Address 2'},
  { format: '', required: 'Yes', pagetab: '2', id: 'member_town', question: 'Town'},
  { format: '', required: 'Yes', pagetab: '2', id: 'member_county', question: 'County'},
  { format: '', required: 'Yes', pagetab: '2', id: 'member_country', question: 'Country'},
  { format: '', required: 'Yes', pagetab: '2', id: 'member_telephone', question: 'Telephone'},
  { format: '', required: 'Yes', pagetab: '2', id: 'member_email', question: 'Email'},
  { format: '', required: 'Yes', pagetab: '2', id: 'member_contactPreferencePhone', question: 'Contact by phone'},
  { format: '', required: 'Yes', pagetab: '2', id: 'member_contactPreferenceEmail', question: 'Contact by email'},
  { format: '', required: 'Yes', pagetab: '2', id: 'member_contactPreferencePost', question: 'Contact by post'},
  { format: 'date', required: 'Yes', pagetab: '2', id: 'member_DOB', question: 'Date of Birth'},
  { format: '', required: 'Yes', pagetab: '3', id: 'illnessInjury_what', question: 'What happened'},
  { format: '', required: 'Yes', pagetab: '3', id: 'illnessInjury_how', question: 'How did it happen'},
  { format: '', required: 'Yes', pagetab: '3', id: 'illnessInjury_prevent_working', question: 'How has this prevented the claimant from working'},
  { format: 'date', required: 'Yes', pagetab: '3', id: 'illnessInjury_when', question: 'When did the injury occur'},
  { format: '', required: 'Yes', pagetab: '3', id: 'illnessInjury_where', question: 'Geographically where did the injury occur'},
  { format: '', required: 'Yes', pagetab: '3', id: 'illnessInjury_history', question: 'Do you have prior History'},
  { format: '', required: 'Yes', pagetab: '3', id: 'illnessInjury_consultation', question: 'Have you consulted with an expert'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_firstName', question: 'Doctor First Name'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_lastName', question: 'Doctor Last Name'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_telephone', question: 'Doctor Last Telephone'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_postcode', question: 'Doctor Postcode'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_addressLine1', question: 'Doctor Address 1'},
  { format: '', required: 'No', pagetab: '3', id: 'doctor_addressLine2', question: 'Doctor Address 2'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_town', question: 'Doctor Town'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_county', question: 'Doctor County'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_country', question: 'Doctor Country'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_changed', question: 'Has your Doctor changed'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_changed_firstName', question: 'Previous Doctor First Name'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_changed_lastName', question: 'Previous Doctor Last Name'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_changed_telephone', question: 'Previous Doctor Telephone'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_changed_postcode', question: 'Previous Doctor Postcode'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_changed_addressLine1', question: 'Previous Doctor Address Line 1'},
  { format: '', required: 'No', pagetab: '3', id: 'doctor_changed_addressLine2', question: 'Previous Doctor Address Line 2'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_changed_town', question: 'Previous Doctor Address Town'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_changed_county', question: 'Previous Doctor Address County'},
  { format: '', required: 'Yes', pagetab: '3', id: 'doctor_changed_country', question: 'Previous Doctor Address Country'},
  { format: '', required: 'Yes', pagetab: '3', id: 'illnessInjury_treatment', question: 'Treatment'},
  { format: '', required: 'Yes', pagetab: '3', id: 'illnessInjury_hospitalised', question: 'Have you been Hospitalised'},
  { format: 'origo', required: 'Yes', pagetab: '4', id: 'occupation_main_origo', question: 'Main Occupation'},
  { format: '', required: 'No', pagetab: '4', id: 'occupation_main_further', question: 'Main Occupation more detail'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_status', question: 'Occupation Status'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_employer_name', question: 'Employer Name'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_employer_telephone', question: 'Employer Telephone'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_employer_email', question: 'Employer Email'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_postcode', question: 'Employer Postcode'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_addressLine1', question: 'Employer Address Line 1'},
  { format: '', required: 'No', pagetab: '4', id: 'occupation_addressLine2', question: 'Employer Address Line 2'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_town', question: 'Employer Address Town'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_county', question: 'Employer Address County'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_further_accountantholdrecords', question: 'Does you accountant hold financial records'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_accountant_name', question: 'Accountant Name'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_accountant_telephone', question: 'Accountant Telephone'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_accountant_email', question: 'Accountant Email'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_accountant_postcode', question: 'Accountant Postcode'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_accountant_addressLine1', question: 'Accountant Address Line 1'},
  { format: '', required: 'No', pagetab: '4', id: 'occupation_accountant_address_Line2', question: 'Accountant Address Line 2'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_accountant_town', question: 'Accountant Town'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_accountant_county', question: 'Accountant County'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd', question: 'Do you have a secondary occupation'},
  { format: 'origo', required: 'Yes', pagetab: '4', id: 'occupation_2nd_origo', question: 'Secondary occupation'},
  { format: '', required: 'No', pagetab: '4', id: 'occupation_2nd_further', question: 'Secondary occupation more detail'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_status', question: 'Secondary occupation status'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_name', question: 'Secondary Employer Name'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_telephone', question: 'Secondary Employer Telephone'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_email', question: 'Secondary Employer Email'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_postcode', question: 'Secondary employer postcode'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_addressLine1', question: 'Secondary employer address line 1'},
  { format: '', required: 'No', pagetab: '4', id: 'occupation_2nd_addressLine2', question: 'Secondary employer address line 2'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_town', question: 'Secondary employer address town'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_county', question: 'Secondary employer address county'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_further_accountantholdrecords', question: 'Does you second accountant hold financial records'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_accountant_name', question: 'Second Accountant Name'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_accountant_telephone', question: 'Second Accountant Telephone'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_accountant_email', question: 'Second Accountant Email'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_accountant_postcode', question: 'Second Accountant Postcode'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_accountant_addressLine1', question: 'Second Accountant Address Line 1'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_accountant_addressLine2', question: 'Second Accountant Address Line 2'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_accountant_town', question: 'Second Accountant Town'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_2nd_accountant_county', question: 'Second Accountant County'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_more', question: 'Do you have more than two occupations'},
  { format: '', required: 'Yes', pagetab: '4', id: 'occupation_changed12Months', question: 'Has your occupation changed in the last 12 months'},
  { format: '', required: 'Yes', pagetab: '5', id: 'benefit_continuedEarningsSSP', question: 'Continued Earnings including Statutory Sick Pay'},
  { format: '', required: 'Yes', pagetab: '5', id: 'benefit_EarlyRetirement', question: 'Early Retirement income'},
  { format: '', required: 'Yes', pagetab: '5', id: 'benefit_workPensions', question: 'Works and Pension'},
  { format: '', required: 'Yes', pagetab: '5', id: 'benefit_otherInsurance', question: 'Other Insurance'},
  { format: '', required: 'Yes', pagetab: '6', id: 'payments', question: 'Where would you want the payment to be made'},
  { format: '', required: 'Yes', pagetab: '6', id: 'furtherInformation', question: 'Any Further information'},
  { format: '', required: 'Yes', pagetab: '6', id: 'furtherInformation_more', question: 'Further Information'},
  { format: '', required: 'Yes', pagetab: '6', id: 'discussClaimOthers', question: 'Discuss with third party'},
  { format: '', required: 'Yes', pagetab: '6', id: 'discussClaimOthers_more', question: 'Third party details'}
];
